import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";
import { UserAdsStatisticsI } from "../../../typings/routesTypes";

const USER_ADS_STATISTICS_GET = "USER_ADS_STATISTICS_GET";
const USER_ADS_STATISTICS_CLEAR = "USER_ADS_STATISTICS_CLEAR";

// Actions
export const getUserAdsStatistics = createAction(
  USER_ADS_STATISTICS_GET,
  async (userId: string, params: { startDate?: string; endDate?: string } = {}) => {
    try {
      return await api.User.userAdsStatistics(userId, params);
    } catch (error) {
      return null;
    }
  }
);

export const clearUserAdsStatistics = createAction(USER_ADS_STATISTICS_CLEAR);

// Selectors
export const selectUserAdsStatistics = (state) => state.admin.userStatistics.statistics;

// Reducer
const initialState = {
  statistics: null,
};

export default handleActions(
  {
    [USER_ADS_STATISTICS_GET]: (state, { payload }) => ({
      ...state,
      statistics: payload,
    }),
    [USER_ADS_STATISTICS_CLEAR]: (state) => ({
      ...state,
      statistics: null,
    }),
  },
  initialState
);


// WEBPACK FOOTER //
// ./src/routes/Admin/UserStatisticsPage/userStatistics.ducks.ts